import { useEffect, useState } from "react";
import { getComplaint } from "../../../action/complaintAction";
import { PageInfoHeader } from "../../../component/comman/PageInfoHeader";
import { fDateUTC } from "../../../utils/helper/timeHelpers";
import Pagination from "../../../comman/Pagination";
import { _vendorAdminRoutes } from "../../../utils/appRouter";
import {  useNavigate } from "react-router-dom";

const Complaints = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [complaints, setComplaints] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const limit = 5;

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
   const navigate = useNavigate();

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1);
    }, 500);

    return () => clearTimeout(handler);
  }, [search]);

  const fetchComplaint = async () => {
    try {
      setIsLoading(true);

      const resp = await getComplaint({
        offset: (page - 1) * limit,
        limit,
        searchQ: debouncedSearch,
        role: "SUPPORT_TEAM",
      });

      if (resp?.status === 200 || resp?.success === true) {
        setComplaints(resp?.data?.tickets || []);
        setTotal(resp?.data?.total);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

    const handleView = (id) => {
      navigate(_vendorAdminRoutes.complaintsDetails(id))
    };

  useEffect(() => {
    fetchComplaint();
  }, [page, debouncedSearch]);


  return (
    <section className="content mb-5">
      <div className="container-fluid">

        {/* HEADER */}
        <div className="row titlepad">
          <div className="col-md-12">
            <div className="mt-3 mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>

            <div className="row align-items-end">
              <div className="col-sm-9">
                <h4>Complaints</h4>

                <PageInfoHeader
                  page={page}
                  limit={limit}
                  total={total}
                  label="list of complaints"
                />
              </div>

              <div className="col-md-3">
                <input
                  className="form-control searchinput"
                  type="text"
                  placeholder="Search Complaints..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        {/* LISTING */}
        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="table-responsive bg-white">
              <table className="table table-striped table-bordered admintable border-0">
                <tbody>
                  <tr>
                    <th>#</th>
                    <th>Customer Name</th>
                    <th>Complaint Date</th>
                    <th>Order No</th>
                    <th>Category</th>
                    <th>Description</th>
                    <th>Action</th>
                  </tr>

                  {isLoading ? (
                    <tr>
                      <td colSpan={10} className="text-center py-4">
                        Loading...
                      </td>
                    </tr>
                  ) : complaints.length > 0 ? (
                    complaints.map((complaint, index) => (
                      <tr key={complaint._id}>
                        <td>{(page - 1) * limit + (index + 1)}</td>
                        <td>
                          {complaint?.user?.userName || '-'}
                          <br />
                          {complaint?.user?.dialCode} {complaint?.user?.mobileNo}
                        </td>
                        <td>
                          {complaint?.createdAt ? fDateUTC(complaint?.createdAt, null, "DD MMM YYYY") : '-'}
                        </td>
                        <td>{complaint?.orderdetail?.orderNo || '-'}</td>
                        <td>{complaint?.supportCategoryDetail?.name || '-'}</td>
                        <td className="truncate">{complaint?.description || '-'}</td>
                         <td>
                          <button
                              className="dropdown-item"
                              onClick={() => handleView(complaint._id)}
                              >
                              <i className="fa fa-eye"></i> View Details
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={10} className="text-center py-4">
                        No complaint found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="text-center mt-4">
              <Pagination
                page={page}
                limit={limit}
                total={total}
                onPageChange={(newPage) => setPage(newPage)}
                showAlways={true}
              />
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default Complaints;
